// 职位列表
import React from 'react'
import LxHeader from '@/components/LxHeader/One'
import {Collapse, Input, Divider, Pagination, ConfigProvider, Tooltip} from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons';
import zhCN from 'antd/es/locale/zh_CN'
import { getPositionlistSearchTermApi, getPositionlist } from '@/api'
import styles from './index.module.scss'
import defaultSetting from '@/setting'
import { getUrlParams } from '@/utils/util'
const banner01 = require('@/assets/images/positionList/banner01.png')
const banner02 = require('@/assets/images/positionList/banner02.png')
const iconOpen = require('@/assets/images/positionList/open.png')
const iconClose = require('@/assets/images/positionList/close.png')
const checked01 = require('@/assets/images/positionList/checked01.png')
const checked02 = require('@/assets/images/positionList/checked02.png')
const uncheck = require('@/assets/images/positionList/uncheck.png')
const search = require('@/assets/images/positionList/search.png')

class PositionList extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            collapseActiveKey: ["1", "2", "3"],
            schoolProject: [
                {nameCh: '应届生招聘', code: '205701', recruitType: '1'},
                {nameCh: '"双百"计划', code: '205801', recruitType: '1'},
                {nameCh: '博士生招聘', code: '205601', recruitType: '1'},
                {nameCh: '红旗学院', code: '202902', recruitType: '12'},
                {nameCh: '实习生', code: '100301', recruitType: '12'},
                // {nameCh: '红旗学院', code: '100206', recruitType: '12'},
                // {nameCh: '蓝领', code: '100205', recruitType: '12'},
                {nameCh: '三地招聘', code: '203201', recruitType: '1'},
            ],   // 招聘项目列表
            socialProject: [
                {nameCh: '高端领军人才', code: '205202', recruitType: '2'},
                {nameCh: '社会成熟人才', code: '205201', recruitType: '2'},
            ],   // 招聘项目列表
            cityList: [],   // 工作地点列表
            postTypeList: [],   // 职位类别列表
            orgList: [],   // 机构列表
            secondLevelOrgList: [],   // 二级机构列表
            positionPageForm: '',   // 职位列表
            screenData: {
                projectCode: [],   // 招聘项目
                postTypeCode: [],   // 职位类别
                cityCode: [],   // 工作地点
                orgCode: '',   // 一级机构
                secondLevelOrgCode: [],   // 二级机构
                searchValue: '',   // 搜索
            },   // 筛选参数
            currentRecruitType: '',  // 当前的招聘类型
            secondLevelIndex: '',   // 二级数据插入的索引
        }
    }

    // 折叠面板操作
    collapseHandle = (key) => {
        this.setState({
            collapseActiveKey: key
        })
    }

    // 获取筛选数据
    getScreenList = (isSecondLevelOrg) => {
        let {currentRecruitType, secondLevelOrgList, screenData} = this.state;
        let {orgCode} = getUrlParams();

        if (isSecondLevelOrg && screenData && screenData.orgCode) orgCode = screenData.orgCode;

        getPositionlistSearchTermApi({
            recruitType: currentRecruitType,
            workPlace: 1,
            postType: 1,
            org: 1,
        }).then(res => {
            if (res.data) {
                let {cityList, orgList, postTypeList} = res.data;
                let newPostTypeList = [];

                orgList.unshift({nameCh: '全部', code: ''});

                if(orgCode){
                    for (let i = 0; i < orgList.length; i++) {
                        if (orgList[i].code === orgCode && orgList[i].childNodes) secondLevelOrgList = orgList[i].childNodes;
                    }
                }

                postTypeList.map((item) => {
                    if (item.childNodes && item.childNodes.length) {
                        newPostTypeList = [...newPostTypeList, ...item.childNodes];
                    }
                });
                postTypeList = newPostTypeList;

                this.setState({
                    cityList, orgList, postTypeList, secondLevelOrgList,
                },()=>{
                    if (orgCode) this.getAddSecondLevelOrgIndex();
                })
            }
        })
    }

    // 获取筛选参数
    getScreenData = (type, code, item) => {
        let {screenData, currentRecruitType, secondLevelOrgList} = this.state;
        let isAgainGetScreenList = false;

        if (type === 'project') {
            // 社招招聘项目可多选
            if (currentRecruitType === '2') {
                let projectCode = screenData.projectCode || [];
                if (projectCode.indexOf(code) !== -1) {
                    projectCode = projectCode.filter(item => item !== code);
                } else {
                    projectCode.push(code);
                }
                screenData.projectCode = projectCode;
            }else{
                if (screenData.projectCode.indexOf(code) !== -1) return;
                screenData.projectCode = [code];
            }

            // 切换招聘类型时，重新请求筛选数据，并清空筛选条件
            if (currentRecruitType !== item.recruitType) {
                secondLevelOrgList = [];
                currentRecruitType = item.recruitType;
                screenData.postTypeCode = [];
                screenData.cityCode = [];
                screenData.orgCode = '';
                screenData.secondLevelOrgCode = [];
                screenData.searchValue = '';
                isAgainGetScreenList = true;
            }
        } else if (type === 'postType') {
            let postTypeCode = screenData.postTypeCode || [];
            if (postTypeCode.indexOf(code) !== -1) {
                postTypeCode = postTypeCode.filter(item => item !== code);
            } else {
                postTypeCode.push(code);
            }
            screenData.postTypeCode = postTypeCode;
        } else if (type === 'city') {
            let cityCode = screenData.cityCode || [];
            if (cityCode.indexOf(code) !== -1) {
                cityCode = cityCode.filter(item => item !== code);
            } else {
                cityCode.push(code);
            }
            screenData.cityCode = cityCode;
        } else if (type === 'org') {
            if (code.split('/').length === 2) {
                screenData.orgCode = code;
                screenData.secondLevelOrgCode = [];

                // 获取二级机构
                if (item.childNodes) {
                    secondLevelOrgList = item.childNodes;
                } else {
                    secondLevelOrgList = [];
                }

                this.getAddSecondLevelOrgIndex();
            } else if (code === '') {
                screenData.orgCode = '';
                screenData.secondLevelOrgCode = [];
                secondLevelOrgList = [];
            } else if (code.split('/').length > 2) {
                let secondLevelOrgCode = screenData.secondLevelOrgCode || [];
                if (secondLevelOrgCode.indexOf(code) !== -1) {
                    secondLevelOrgCode = secondLevelOrgCode.filter(item => item !== code);
                } else {
                    secondLevelOrgCode.push(code);
                }
                screenData.secondLevelOrgCode = secondLevelOrgCode;
            }
        }

        this.setState({
            screenData,
            currentRecruitType,
            secondLevelOrgList,
        }, () => {
            if (isAgainGetScreenList) this.getScreenList();
            this.getPositionList();

            // 如果搜索框不在可视区域内，则滚动条定位
            // let searchCon = document.querySelector('.searchCon');
            // let offsetTop = searchCon.offsetTop;
            // let scrollTop = document.querySelector('html').scrollTop;
            // if (offsetTop < scrollTop) {
            //     if (document.querySelector('html').scrollTo) {
            //         document.querySelector('html').scrollTo({
            //             top: offsetTop - 136,
            //             behavior: "smooth"
            //         });
            //     } else {
            //         document.querySelector('html').scrollTop = offsetTop - 136;
            //     }
            // }
        })
    }

    // 搜索
    onSearch = (value) => {
        let {screenData} = this.state;

        screenData.searchValue = value;

        this.setState({
            screenData
        }, () => this.getPositionList())
    }

    // 搜索框内容变化时的回调
    onChange = (e) => {
        let {screenData} = this.state;

        screenData.searchValue = e.target.value;

        this.setState({
            screenData
        })
    }

    // 获取职位列表
    getPositionList = (data) => {
        const {currentRecruitType, screenData, secondLevelIndex, socialProject} = this.state;
        let postData = {
            recruitType: currentRecruitType,
            pageSize: 10,
            currentPage: 1,
        };

        if (screenData.projectCode.length) postData.externalProjectStr = screenData.projectCode.join(',');
        if(screenData.postTypeCode.length) postData.postTypeCode = screenData.postTypeCode.join(',');
        if(screenData.cityCode.length) postData.workPlaceCode = screenData.cityCode.join(',');
        if(screenData.searchValue) postData.postKey = screenData.searchValue;
        if (screenData.secondLevelOrgCode.length) {
            postData.orgCode = screenData.secondLevelOrgCode.join(',');
        } else {
            if(screenData.orgCode) postData.orgCode = screenData.orgCode;
        }

        // 存储筛选条件参数
        sessionStorage.setItem('screenData', JSON.stringify({
            data: screenData,
            url: window.location.search,
            currentRecruitType,
            currentSecondLevelIndex: secondLevelIndex,
        }));

        // 社会招聘 - 什么项目都不选时，和所有项目全选保持相同的数据
        if (postData.recruitType === '2' && !postData.externalProjectStr) {
            let projectCode = [];
            socialProject.map((item) => projectCode.push(item.code));
            postData.externalProjectStr = projectCode.join(',');
        }

        if (data) postData = {...postData, ...data};

        getPositionlist(postData).then(res => {
            this.setState({
                positionPageForm: res.data.pageForm,
            })
        })
    }

    // 分页
    pageChange = (page) => {
        this.getPositionList({currentPage: page});
    }

    // 获取追加二级数据的索引
    getAddSecondLevelOrgIndex = () => {
        let that = this;
        setTimeout(function () {
            let orgLists = document.querySelectorAll('.orgLists');
            let activeTop;
            let addIndex = '';

            for (let i = 0; i < orgLists.length; i++) {
                if (orgLists[i].getAttribute('class').indexOf('active') !== -1) {
                    activeTop = orgLists[i].offsetTop;
                }

                if (activeTop && (activeTop + 20 < orgLists[i].offsetTop) && addIndex === '') {
                    addIndex = i;
                }
            }

            if (!addIndex) addIndex = orgLists.length;

            that.setState({
                secondLevelIndex: addIndex
            })
        })
    }

    componentWillMount() {
        if (defaultSetting.grayscale) {
            document.querySelector('html').classList.add('grayscale');
        }
    }

    componentDidMount() {
        let {screenData, schoolProject, socialProject, secondLevelIndex} = this.state;
        let {recruitType, projectId, orgCode} = getUrlParams();

        if (recruitType) {
            let list = recruitType === '2' ? socialProject : schoolProject;
            let projectCode = '';
            let firstCode = '';

            for (let i = 0; i < list.length; i++) {
                if (list[i].recruitType === recruitType) {
                    if (!firstCode) firstCode = list[i].code;

                    if (projectId && list[i].code === projectId) {
                        projectCode = projectId;
                    }
                }
            }

            screenData.projectCode.push(projectCode ? projectCode : firstCode);
        }

        if (orgCode) screenData.orgCode = orgCode;

        // 获取存储的筛选条件参数
        let storageScreenData = JSON.parse(sessionStorage.getItem('screenData'));
        let isSecondLevelOrg = false;
        if (storageScreenData) {
            const {data, url, currentRecruitType, currentSecondLevelIndex} = storageScreenData;
            let currentSearch = window.location.search;
            if (currentSearch === url) {
                screenData = data;
                if (currentRecruitType) recruitType = currentRecruitType;
                if(screenData.secondLevelOrgCode.length) {
                    secondLevelIndex = currentSecondLevelIndex;
                    isSecondLevelOrg = true;
                }
            }
        }

        this.setState({
            screenData,
            currentRecruitType: recruitType,
            secondLevelIndex,
        }, () => {
            this.getScreenList(isSecondLevelOrg);
            this.getPositionList();
        })
    }
    render() {
        const {
            collapseActiveKey, schoolProject, socialProject, orgList, positionPageForm, screenData, cityList, postTypeList,
            secondLevelOrgList, secondLevelIndex, currentRecruitType,
        } = this.state;
        const {projectCode, postTypeCode, cityCode, orgCode, secondLevelOrgCode} = screenData || '';
        const {recruitType} = getUrlParams();
        return (
            <>
                <LxHeader></LxHeader>
                <main className={styles.positionList}>
                    <div className="positionListBanner">
                        <img className="lx-w100" src={recruitType === '2' ? banner02 : banner01} alt="banner"/>
                    </div>
                    <div className="positionListCon">
                        <div className="listLeft">
                            <div className="positionNum">
                                <p><span>{positionPageForm.dataCount || 0}</span>个在招职位</p>
                            </div>
                            <div className="positionScreen">
                                <div className="screenList">
                                    <Collapse activeKey={collapseActiveKey} ghost onChange={this.collapseHandle}>
                                        <Collapse.Panel key="1" showArrow={false} collapsible={'disabled'}
                                            header={
                                                <div className="screenTitle">
                                                    <p>招聘项目</p>
                                                    {/*<img src={collapseActiveKey.indexOf('1') !== -1 ? iconClose : iconOpen} alt="open"/>*/}
                                                </div>
                                            }
                                        >
                                            <div className="screenContent">
                                                {(recruitType === '2' ? socialProject : schoolProject).map((item) => {
                                                    let showTooltip = false;
                                                    let tooltipTitle = '';

                                                    if (recruitType === '1') {
                                                        if (item.code === '204802') {
                                                            showTooltip = true;
                                                            tooltipTitle = '“双百”顶尖人才计划立足中国一汽百人接续奋斗、百年基业长青，每年面向全球顶尖高校择优选拔100名优秀人才，中国一汽将充分利用各方面资源，设计专属发展通道、倾斜配置培养资源、压缩培养锻炼周期，提高薪酬福利待遇，加快“双百”顶尖人才快速成长。'
                                                        }

                                                        if (item.code === '203201') {
                                                            showTooltip = true;
                                                            tooltipTitle = '面向西藏、青海、新疆三省区及四川、云南、甘肃三省涉藏州县高校毕业生（含当地学籍和入学前户籍所在地为当地的毕业生）';
                                                        }
                                                    }

                                                    return(
                                                        <div className="screenOptions" key={item.code}
                                                            onClick={()=>this.getScreenData('project', item.code, item)}
                                                        >
                                                            <img src={projectCode.indexOf(item.code) !== -1 ? (recruitType === '2' ? checked02 : checked01) : uncheck} alt="choose"/>
                                                            <p>
                                                                {item.nameCh}
                                                                { showTooltip && tooltipTitle ?
                                                                    <span style={{ marginLeft:'5px'}}>
                                                                        <Tooltip
                                                                            title={tooltipTitle}
                                                                            overlayStyle={{borderRadius:'8px'}} overlayInnerStyle={{borderRadius:'8px'}}><QuestionCircleOutlined /></Tooltip>
                                                                    </span>:null
                                                                }
                                                            </p>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </Collapse.Panel>
                                        <Collapse.Panel key="2" showArrow={false}
                                            header={
                                                <div className="screenTitle">
                                                    <p>职位类别</p>
                                                    <img src={collapseActiveKey.indexOf('2') !== -1 ? iconClose : iconOpen} alt="open"/>
                                                </div>
                                            }
                                        >
                                            <div className="screenContent">
                                                {postTypeList.map((item)=>{
                                                    return(
                                                        <div className="screenOptions" key={item.code}
                                                            onClick={()=>this.getScreenData('postType', item.code)}
                                                        >
                                                            <img src={postTypeCode && postTypeCode.indexOf(item.code) !== -1 ? checked02 : uncheck} alt="choose"/>
                                                            <p>{item.nameCh}</p>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </Collapse.Panel>
                                        <Collapse.Panel key="3" showArrow={false}
                                            header={
                                                <div className="screenTitle">
                                                    <p>工作地点</p>
                                                    <img src={collapseActiveKey.indexOf('3') !== -1 ? iconClose : iconOpen} alt="open"/>
                                                </div>
                                            }
                                        >
                                            <div className="screenContent">
                                                {cityList.map((item)=>{
                                                    return(
                                                        <div className="screenOptions" key={item.code}
                                                            onClick={()=>this.getScreenData('city', item.code)}
                                                        >
                                                            <img src={cityCode && cityCode.indexOf(item.code) !== -1 ? checked02 : uncheck} alt="choose"/>
                                                            <p>{item.nameCh}</p>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </Collapse.Panel>
                                    </Collapse>
                                </div>
                            </div>
                        </div>
                        <div className="listRight">
                            <div className="searchCon">
                                <Input.Search
                                    bordered={false}
                                    placeholder="搜索关键字"
                                    allowClear
                                    enterButton={<p><img className="searchIcon" src={search} alt="search"/> 搜索</p>}
                                    size="large"
                                    onSearch={this.onSearch}
                                    onChange={this.onChange}
                                    value={screenData.searchValue}
                                />
                            </div>
                            <div className="orgCon">
                                {
                                    orgList.map((item, index) => {
                                        return (
                                            <React.Fragment key={index}>
                                                <div
                                                    className={`orgLists${item.code === orgCode ? ' active' : ''}`}
                                                    onClick={() => this.getScreenData('org', item.code, item)}
                                                >{item.nameCh}</div>
                                                {
                                                    secondLevelIndex && secondLevelIndex - 1 === index && secondLevelOrgList.length ? <div className="secondLevelOrgCon">
                                                        {
                                                            secondLevelOrgList.map((item)=>{
                                                                return(
                                                                    <div
                                                                        key={item.code}
                                                                        className={`secondLevelOrgLists${secondLevelOrgCode && secondLevelOrgCode.indexOf(item.code) !== -1 ? ' active' : ''}`}
                                                                        onClick={() => this.getScreenData('org', item.code, item)}
                                                                    >{item.nameCh}</div>
                                                                )
                                                            })
                                                        }
                                                    </div> : ''
                                                }
                                            </React.Fragment>
                                        )
                                    })
                                }
                            </div>
                            <div className="positionCon">
                                {
                                    positionPageForm && positionPageForm.pageData ? positionPageForm.pageData.length ? positionPageForm.pageData.map((item, index) => {
                                        let postType;
                                        if (currentRecruitType === '1') {
                                            postType = 'campus';
                                        } else if (currentRecruitType === '2') {
                                            postType = 'society';
                                        } else if (currentRecruitType === '12') {
                                            postType = 'intern';
                                        } else if (currentRecruitType === '13') {
                                            postType = 'overseas';
                                        }
                                        return(
                                            <a className="positionLists" key={item.postId} href={`/${defaultSetting.suiteKey}/pb/posDetail.html?postId=${item.postId}&postType=${postType}`}>
                                                <div className="positionName" title={item.postName}>{item.postName}</div>
                                                <div className="positionInfos">
                                                    <span>{item.departmentName ? item.departmentName : item.company}</span>
                                                    <Divider type="vertical"/>
                                                    <span>{item.postTypeName}</span>
                                                    <Divider type="vertical"/>
                                                    <span>{item.workPlaceStr}</span>
                                                </div>
                                                <div className="positionInfos noDivider">
                                                    <span>发布时间：{item.publishDate}</span>
                                                    <span>招聘人数：{isNaN(Number(item.recruitNumStr)) ? '若干' : item.recruitNumStr + '人'}</span>
                                                    {/*<span>招聘项目：{item.projectName}</span>*/}
                                                </div>
                                            </a>
                                        )
                                    }) : '' : ''
                                }
                            </div>
                            {
                                positionPageForm && positionPageForm.dataCount && positionPageForm.dataCount > 10 ?
                                    <div className="paginationCon">
                                        <ConfigProvider locale={zhCN}>
                                            <Pagination
                                                showQuickJumper
                                                showSizeChanger={false}
                                                pageSize={positionPageForm.pageSize || 10}
                                                total={positionPageForm.dataCount || 0}
                                                onChange={this.pageChange}
                                                current={positionPageForm.currentPage || 1}
                                            />
                                        </ConfigProvider>
                                    </div> : ''
                            }
                        </div>
                    </div>
                </main>
            </>
        )
    }
}
export default PositionList;
